import { render, staticRenderFns } from "./profile-juridical.vue?vue&type=template&id=c2a76e4a&scoped=true"
import script from "./profile-juridical.vue?vue&type=script&lang=js"
export * from "./profile-juridical.vue?vue&type=script&lang=js"
import style0 from "./profile-juridical.vue?vue&type=style&index=0&id=c2a76e4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a76e4a",
  null
  
)

export default component.exports